export default () => {
	if (document.querySelector('#hlw1')) {
		console.log('video page');
		$('.video__thumbnail').each(function(i, video){
			setVimeoPlayer(video);
		});
		function setVimeoPlayer(video) {
			//console.log('video: ',video);
			var parent = $(video).parent();
			var modal = $(video).parent().find('.video__modal');
			var iframe = $(video).parent().find('iframe')[0];
			var player = new Vimeo.Player(iframe);

			// bind player to .video.data
			$(parent).data("player", player);

			// handle thumbnail click
			$(video).click(function(){
				parent.addClass('isActive');
				player.play();
			});

			// handle modal click
			modal.click(function(){
				parent.removeClass('isActive');
				player.pause();
			})

			gtmVideoPlayer(player);

		}

		function gtmVideoPlayer(player) {
			var title;
			var progress = 0;
      		var lastSecondsComplete = 0;
			player.getVideoTitle().then(function(v) {
				title=v;
				player.on('play', function() {
					window.dataLayer.push({
						event: 'videoPlay',
						eventCategory: 'Video-Plays',
						eventAction: title,
						eventLabel: 'Start'
					})
				})

				player.on('ended', function() {
					window.dataLayer.push({
						event: 'videoPlay',
						eventCategory: 'Video-Plays',
						eventAction: title,
						eventLabel: 'End'
					})
				})

				player.on("timeupdate", function(data) {
					var prev_progress = progress;
			
					if (data.percent >= 0.99 && progress < 0.99) {
					  progress = 1.0;
					} else if (data.percent >= 0.9 && progress < 0.9) {
					  progress = 0.9;
					} else if (data.percent >= 0.8 && progress < 0.8) {
					  progress = 0.8;
					} else if (data.percent >= 0.7 && progress < 0.7) {
					  progress = 0.7;
					} else if (data.percent >= 0.6 && progress < 0.6) {
					  progress = 0.6;
					} else if (data.percent >= 0.5 && progress < 0.5) {
					  progress = 0.5;
					} else if (data.percent >= 0.4 && progress < 0.4) {
					  progress = 0.4;
					} else if (data.percent >= 0.3 && progress < 0.3) {
					  progress = 0.3;
					} else if (data.percent >= 0.2 && progress < 0.2) {
					  progress = 0.2;
					} else if (data.percent >= 0.1 && progress < 0.1) {
					  progress = 0.1;
					}
			  
					// Handle seconds
					var secondsComplete = Math.floor(data.seconds);
			  
					if ( Math.floor(secondsComplete / 10) > Math.floor(lastSecondsComplete / 10)) {
					  window.dataLayer.push({
						event: 'videoSeconds',
						eventCategory: 'Video-Interval-Seconds',
						eventAction: title,
						eventLabel: String((Math.floor(secondsComplete / 10) * 10 + "s"))
					})
					  lastSecondsComplete = secondsComplete;
					}
			  
					if (prev_progress !== progress) {
					  window.dataLayer.push({
						event: 'videoPercentage',
						eventCategory: 'Video-Interval-Percent',
						eventAction: title,
						eventLabel: progress * 100 + "%"
					})
					}
				  });
			});
		}

		function getQueryString() {
			return new URLSearchParams(location.search);
		}

		function checkForVideoQuery() {
			var queryObj = getQueryString();
			//console.log(queryObj);

			//check if queryObj has vid name:value pair
			if (queryObj.get('vid')) {
				var calledVideo = queryObj.get('vid');
				//console.log('video called:', calledVideo);
				$(`#${calledVideo}`).addClass('isActive');
			}

		}
		checkForVideoQuery();

	}
};


